// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import VueRouter from "vue-router";

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")

require("jquery")
require("jquery-ui")
require("../src/rails_autocomplete")
require("expose-loader?$!jquery")
require("jquery-mask-plugin")
require("semantic-ui-css/semantic.min.js")
require("semantic-ui-css/semantic.min.css")
require("../stylesheets/application.css")
require("jquery-ui-dist/jquery-ui.min.css")
require("trix/dist/trix.css")
require("../stylesheets/actiontext.scss")
require("../stylesheets/abitur_admission_activs.scss")
require("tablesorter")
require("cocoon-js")
require("trix")
require("@rails/actiontext")

import '../src/admin_area'
import '../src/explore'
import '../src/abitur_admission_activs'
import '../src/disciplines'
import '../src/edu_objects'
import '../src/educational_programms'
import '../src/groups'
import '../src/organization_gens'
import '../src/prtf_achievements'
import '../src/study_gradebooks'
import '../src/timetable_tamplates'

import Vue from 'vue/dist/vue.esm';
import VueTheMask from 'vue-the-mask';
import TurbolinksAdapter from 'vue-turbolinks';
import Axios from 'axios';
import VueAxios from 'vue-axios';
import moment from 'moment'
import Vue2Editor from "vue2-editor";

Vue.prototype.moment = moment
Vue.use(VueTheMask)
Vue.use(VueAxios, Axios);
Vue.use(TurbolinksAdapter);
Vue.use(Vue2Editor);
Vue.use(VueRouter);

import '../components/application/index.js.erb';
import katex from 'katex'
import 'katex/dist/katex.min.css'
import store from '../stores/application/index.js.erb'
import vuetify from "../plugins/vuetify_plugin";
import {routes} from "../routes/application"
window.katex = katex

const router =  new VueRouter({
    mode: 'history',
    routes: routes
});


//jQuery.event.props.push("dataTransfer");
document.addEventListener("turbolinks:load", function() {
    const element = document.getElementById('app');
    if (element != null) {
        const app = new Vue({
            vuetify,
            store,
            router,
        }).$mount(element);
    }
    window.ondragover = function(e) { e.preventDefault(); return false };
    // NOTE: ondrop events WILL NOT WORK if you do not "preventDefault" in the ondragover event!!
    window.ondrop = function(e) { e.preventDefault(); return false };
    function allowDrop(ev) {
        ev.preventDefault();
    }

    /*$('input[type=date]').datepicker({
        dateFormat: 'yy-mm-dd',
        changeMonth: true,
        changeYear: true
    });*/
    $('#account_phone').mask('+0(000)000-00-00');
    $('#new_account_form').form({
        on: 'blur',
        fields: {
            email: {
                identifier: 'account_email',
                rules: [
                    {
                        type: 'email',
                        prompt: 'неверный email'
                    },
                    {
                        type: 'empty',
                        prompt: 'email необходимо заполнить'
                    }
                ]
            },
            phone: {
                identifier: 'account_phone',
                rules: [
                    {
                        type: 'empty',
                        prompt: 'Телефон необходимо заполнить'
                    }
                ]
            },
            account_password: {
                identifier: 'account_password',
                rules: [
                    {
                        type: 'empty',
                        prompt: 'Пароль не может быть пустым'
                    },
                    {
                        type: 'minLength[6]',
                        prompt: 'Пароль не может быть меньше 6 символов'
                    }
                ]
            },
            account_password_confirmation: {
                identifier: 'account_password_confirmation',
                rules: [
                    {
                        type: 'minLength[6]',
                        prompt: 'Пароль не может быть меньше 6 символов'
                    },
                    {
                        type: 'empty',
                        prompt: 'Повторите пароль'
                    }
                ]
            }
        }
    })

    $('.field.highlited').on('keyup', 'input', function () {
        var hideinput = $(this).parent().data('id-element');
        if ($(hideinput).val().length == 0 ) {
            $(hideinput).parent().switchClass( 'success', 'warning', 1000, 'easeOutBounce' );
        } else {
            $(hideinput).parent().switchClass( 'warning', 'success', 1000, 'easeOutBounce' );
        };
    });

    $('#content').on('cocoon:after-insert', function(e, insertedItem) {
        $('.ui.dropdown').dropdown({});
        $('.ui.dropdown.clearable').dropdown({clearable: true});
    });

    $('#content').on("cocoon:before-remove", function(e, insertedItem) {
        insertedItem.toggleClass('red');
        insertedItem.prepend("<div class='ui top left attached red label'>Помечен на удаление</div>");
    });
    $('.ui.checkbox').checkbox();
    $('img').each( function () {
        $(this).addClass('ui image');
    });
    $('#toc').sidebar({
        dimPage          : false,
        transition       : 'overlay',
        mobileTransition : 'uncover'
    });
    $('#toc').sidebar('attach events', '.launch.button, .view-ui, .launch.item');
    $('.ui.message .close').on('click', function() {
        $(this).closest('.ui.message').transition('fade');
    });
    $('.sync_button').each(function() {
        var url = $(this).data('link');
        $(this).api({ url: url});
    });

    $('.menu .item').tab();
    $('.ui.dropdown').dropdown({});
    $('.ui.dropdown.optgroup').dropdown({});
    $('.ui.dropdown.clearable').dropdown({clearable: true});
    $('.ui.dropdown.fullText').dropdown({fullTextSearch: true})


    $('.ui.sticky')
        .sticky({
            context: 'section'
        })
    ;
    $('table.sortable').tablesorter();
    $('.ui.accordion').accordion({
        onOpen: function () {
            $("html, body").animate({
                scrollTop: $(this, '.title.active').offset().top - 40
            }, 1000)
        }
    });
    $('.html-popup').popup();

    $('.ui.modal.def').modal({
        allowMultiple: false,
        transition: 'fade down'
    });

    $('.ui.search.discipline').search({
        saveRemoteData:false,
        apiSettings: {
            url: 'reference/disciplines.json?query={query}'
        }
    });

    $('a.speak').on('click', function() {
        window.speechSynthesis.cancel();
        var msg_text = $(this).attr('data-speech');
        var msg = new SpeechSynthesisUtterance(msg_text);
        msg.lang = "ru-RU";
        window.speechSynthesis.speak(msg);
    });

    $('.ui.embed').embed();

    //for exists files
    $('.nested-fields.dropable').on('drop', function(e) {
        $(this).removeClass('purple');
        $(this).addClass('green');

        if(e.originalEvent.dataTransfer){
            if(e.originalEvent.dataTransfer.files.length) {
                e.preventDefault();
                e.stopPropagation();

                $(this).find("input[type='file']").prop('files', e.originalEvent.dataTransfer.files);
            }
        }
    });

    $('.nested-fields.dropable').on('dragover', function(e) {
        $(this).addClass('purple');
    });

    $('.nested-fields.dropable').on('dragleave', function(e) {
        $(this).removeClass('purple');
        e.stopPropagation();
        e.preventDefault();
    });

    $('#document_10, #document_11, #document_15, #document_25, #document_26').on('cocoon:after-insert', function() {
        /*$('.myeditor').froalaEditor({
            initOnClick: true,
            toolbarInline: false,
            file: false,
            language: 'ru'
        });
        import FroalaEditor from "froala-editor/js/froala_editor.min.js";
        global.FroalaEditor = FroalaEditor;

        new FroalaEditor('.myeditor', {
                    initOnClick: true,
                    toolbarInline: false,
                    file: false,
                    language: 'ru'
                });*/
    });

    $('#edu_documentation').on('cocoon:after-insert', function() {
        //for new files
        $('.nested-fields.dropable').on('drop', function(e) {
            $(this).removeClass('purple');
            $(this).addClass('green');

            if(e.originalEvent.dataTransfer){
                if(e.originalEvent.dataTransfer.files.length) {
                    e.preventDefault();
                    e.stopPropagation();

                    $(this).find("input[type='file']").prop('files', e.originalEvent.dataTransfer.files);
                    if($(this).find('.uname').val()==""){
                        $(this).find('.uname').val(e.originalEvent.dataTransfer.files[0].name.replace('.pdf',''))
                    }
                }
            }
        });

        $('.nested-fields.dropable').on('dragover', function(e) {
            $(this).addClass('purple');
        });

        $('.nested-fields.dropable').on('dragleave', function(e) {
            $(this).removeClass('purple');
            e.stopPropagation();
            e.preventDefault();
        });
    });

    $('.ui.buttons .button').on('click', function(){
        $(this).addClass('active');
        $(this).siblings();
        $(this).removeClass('active');
    });
    $('#oop_selected_all').on('change', function() {
        $(".oop-fill-checkbox>input").prop('checked', $(this).prop('checked'));
    });
    $('.popup-item').popup()
});

document.dispatchEvent(new Event("async-loaded"));
document.addEventListener("async-loaded", function() {
    $('.popup-item').popup();
    $('.ui.dropdown').dropdown({});
    $('.ui.checkbox').checkbox();
});


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
